module.exports = __webpack_public_path__ + "img/2.0f7d379f.gif";